import moment from "moment";

export function getMomentDateFromString(params) {

    const actualDate = moment(params.value, "YYYY-MM-DD")

    return params.value !== null ?
        (moment().diff(params.value, "days") > 60 ?
            actualDate.format('YYYY MMM DD') : actualDate.format('ddd MMM DD')) : ''
}

export function getMomentDateFromStringNoDay(params) {

    const actualDate = moment(params.value, "YYYY-MM-DD")

    return params.value !== null ? actualDate.format('yyyy MMM') : ''
}

export function getMomentDateFromStringNoYear(params) {

    const actualDate = moment(params.value, "YYYY-MM-DD")

    return params.value !== null ? actualDate.format('ddd, DD MMM') : ''
}

export function getMomentDateFromStringYear(params) {

    const actualDate = moment(params.value, "YYYY-MM-DD")

    return params.value !== null ? actualDate.format('MMM DD, YYYY') : ''
}